/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-07-25 14:14:20
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbExChangeGoods {
    /**
     * 换货
     */
    export var PostExChangeGoods = (body: any): Promise<any> => {
        return Post(`/api/TbExChangeGoods/PostExChangeGoods`, body);
    };
    
}



// WEBPACK FOOTER //
// ./src/http/api_TbExChangeGoods.ts